<template>
  <div class="logo-wrapper" @click="toDashboard()">
    <div
      v-if="logo"
      :style="{
        'padding-top': logoPadding[0] + 'px',
        'padding-right': logoPadding[1] + 'px',
        'padding-bottom': logoPadding[2] + 'px',
        'padding-left': logoPadding[3] + 'px'
      }"
    >
      <img
        :class="isCircleLogo ? 'logo-img circle-logo' : 'logo-img'"
        :src="logo"
      />
    </div>
    <div v-else class="logo">
      <span>{{ $t('text.logo').toUpperCase() }}</span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    logo() {
      if (this.$store.state.customization.logo) {
        return this.$store.state.customization.logo
      }
      return null
    },
    isCircleLogo() {
      return !!this.$store.state.customization.isCircleLogo
    },
    logoPadding() {
      return this.$store.state.customization.logoPadding || [0, 0, 0, 0]
    }
  },
  methods: {
    toDashboard() {
      this.$router.push('/')
    }
  }
}
</script>
